import { IBeneficiary, TMetaBeneficiary } from '@/features/beneficiaries/store/models/beneficiary.model';

import { TAppError, IBaseAction, IBaseState } from '@/store/types/base.state';

export enum AllBeneficiariesActionTypes {
  SEARCH_ALL_BENEFICIARIES = 'ALL_BENEFICIARIES.SEARCH_ALL_BENEFICIARIES',
  SEARCH_ALL_BENEFICIARIES_SUCCESS = 'ALL_BENEFICIARIES.SEARCH_ALL_BENEFICIARIES_SUCCESS',
  SEARCH_ALL_BENEFICIARIES_FAIL = 'ALL_BENEFICIARIES.SEARCH_ALL_BENEFICIARIES_FAIL',
}

export interface ISearchAllBeneficiariesAction extends IBaseAction {
  type: typeof AllBeneficiariesActionTypes.SEARCH_ALL_BENEFICIARIES;
}

export interface ISearchAllBeneficiariesSuccessAction extends IBaseAction {
  type: typeof AllBeneficiariesActionTypes.SEARCH_ALL_BENEFICIARIES_SUCCESS;
  beneficiaries: IBeneficiary[];
  meta: TMetaBeneficiary;
}

export interface ISearchAllBeneficiariesFailAction extends IBaseAction {
  type: typeof AllBeneficiariesActionTypes.SEARCH_ALL_BENEFICIARIES_FAIL;
  error: TAppError;
}

export type TAllBeneficiariesAction =
  | ISearchAllBeneficiariesAction
  | ISearchAllBeneficiariesSuccessAction
  | ISearchAllBeneficiariesFailAction;

export interface IAllBeneficiariesState extends IBaseState {
  beneficiaries: IBeneficiary[];
  meta: TMetaBeneficiary;
}
